import React, { Component } from 'react';
import { Table, Row, Col, Panel, PanelGroup } from "react-bootstrap";

import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { AgregarDatHistorico, AgregarDatHistoricoElect, EliminarDatHistorico, AddItem, ConsultTipEv, ConsultTipEvAlt,
        GuardarNotaHist, GuardarTeHist, ConsultInscipcion, ConsultPeriodoHist, ConsultElectiva, UpdMatElectiva,
        ConsultLiterales } from "../../../funciones/HistoricoFunction";
import CustomModal from "../../../components/Modal/CustomModal";

import MateriaHistApl from "./MateriaHistApl";

/* let notaResp = ""; */
const ELECTIVA = "ELECTIVA";
class MateriaHist extends Component {
    state = {
        check: false,
        periodo: "",
        te: this.props.datos.te,
        codigoMat: this.props.datos.codigo,
        nota: "",
        enLetras: "",
        valorTe: { value: '', label: '- Selecciona un Tipo de Evaluación -' },
        valorElect: { value: '', label: '- Selecciona una Electiva -', id: '' },
        CualitSelect: { value: "", label: "- SELECCIONA -", aprueba: "", id: '' },
        TeDisp: [{ value: '', label: '- Cargando -' }],
        periodoSelect: {value:"", label: "- Periodos -"},
        periodos: this.props.allperiodos,
        preloader:{
            icon: "fa fa-circle",
            color: "#9A9A9A" 
        },
        openDelMat: false,
        botonSi: <span>Si</span>,
        sel: 2,
        selElec: 2,
        suiche: 0,
        btnDown: true,
        iconChevron: "fa fa-chevron-down",
        control: false,
        notaResp: "",
        Electivas: this.props.electivas,
        Cualit: []
    }

    constructor (props) {
        super (props)
        setTimeout(() => {
            ConsultInscipcion (this.props.est.id, this.props.datos.id, (resp) => {
                this.setState({
                    sel: resp
                })
            })
    
            if ((this.props.datos.Tipo) === "CUALITATIVO"){
                ConsultLiterales ((resp) => {
                    this.setState({
                        Cualit: resp
                    })
                })
            }
    
            if (this.props.datos.Historico[0] !== undefined){
                let tiE = {
                    id: this.props.datos.Historico[0].teid,
                    tipoev_name: this.props.datos.Historico[0].tipoev_name
                }
    
                ConsultTipEv (tiE, (resp) => {
                    this.setState({
                        TeDisp: resp[0],
                        valorTe: resp[1]
                    })
                })
                
                ConsultPeriodoHist (this.props.datos.Historico[0].hid, (resp) => {
                    this.setState({
                        periodoSelect: resp
                    })
                })
    
            }else{
                ConsultTipEvAlt ( (resp) => {
                    this.setState({
                        TeDisp: resp,
                    })
                })
            }
        }, this.props.sec);
    }

    componentDidMount = () => {
        if ((this.props.datos.Tipo) === "CUALITATIVO"){

            ConsultLiterales ((resp) => {

                this.setState({
                    Cualit: resp
                }, () => {  
                    let cualitativo = this.state.Cualit;
                    let notaCualitativo = { value: "", label: "- SELECCIONA -", id: '' };

                    for (let i in cualitativo) {
                        if (this.props.datos.Historico[0] !== undefined){
                            if (cualitativo[i].value === parseInt(this.props.datos.Historico[0].nota)) notaCualitativo = cualitativo[i]
                        }
                    }

                    if (this.props.datos.Historico[0] !== undefined) this.setState({ check: true })
                    this.setState({ CualitSelect: notaCualitativo })
                })
            })
        }

        if (this.props.datos.Historico[0] !== undefined) this.setState({
            periodo: this.props.datos.Historico[0].periodo,
            nota: this.props.datos.Historico[0].nota,
        })

        if (this.props.datos.Historico[0] !== undefined){

            if(this.props.datos.Historico[0].nota !== "") this.setState ({
                check: true,
                control: true,
                openDelMat: false
            }, () => {
                this.enLetras();
            })
        }

        /* Consultar las Electivas */
        let materia = this.props.datos.nombre;
        let search = materia.indexOf(ELECTIVA);
        if(search === 0) {
            ConsultElectiva (this.props.datos.id, this.props.est.id, (resp) => {
                if (resp[0] === 1) {
                    this.setState({
                        selElec: resp[0],
                        valorElect: resp[1],
                        codigoMat: resp[2],
                        periodoSelect: resp[3],
                        valorTe: resp[4],
                        nota: resp[5],
                        check: true,
                        control: true,
                    }, () => {
                        this.enLetras();
                    })
                }else{
                    this.setState({
                        selElec: resp[0]
                    })
                }
            })
        }
    }

    componentWillReceiveProps = (props) => {
        this.setState({ Electivas: props.electivas })

        let { allValorTe, allValorPeriodo, allValorNota } = props;

        if (allValorTe.value !== undefined && allValorTe.value !== "") this.setState({
            valorTe: allValorTe
        }, () => {
            if (this.state.sel !== 1 && this.state.check === true) this.valorSelectTe(allValorTe)
        })

        if (allValorPeriodo.value !== undefined && allValorPeriodo.value !== "") this.setState({
            periodoSelect: allValorPeriodo
        }, () => {
            if (this.state.sel !== 1 && this.state.check === true) this.guardarPeriodo()
        })

        if (allValorNota !== undefined && allValorNota !== "") this.setState({
            nota: allValorNota
        }, () => {
            if (this.state.sel !== 1 && this.state.check === true) this.guardarNota(props.datos.Tipo)
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase(),
            openDelMat: false
        });
    };

    valorElectiva = (valorElect) => {
        if (this.state.check === true) {
            let contenido = {
                value: valorElect.value, label: valorElect.label, id: valorElect.id 
            }
            this.setState({
                valorElect: contenido,
                openDelMat: false,
                preloader:{
                    icon: "fa fa-spinner fa-spin",
                    color: "#9A9A9A"
                },
            }, () => {
                UpdMatElectiva (this.state.valorElect, (resp)=> {
                    if (resp.status === "Ok"){
                        this.setState({
                            preloader:{ icon: "fa fa-check", color: "#32704C" },
                            openDelMat: false
                        })
                    }else{
                        this.setState({
                            preloader:{ icon: "fa fa-times", color: "#A0555C" },
                            openDelMat: false
                        })
                    }
                })
            })
        }else{
            this.setState({
                valorElect,
                openDelMat: false
            })
        }
    }

    modalDelMat = () => {
        let { datos, est } = this.props;
        let { botonSi, openDelMat, valorElect } = this.state;

        let datName = datos.nombre;
        if (datos.Historico[0] !== undefined) datName = datos.Historico[0].materia_name
        let contenidoModal = <div>
            ¿Desea realmente <strong>eliminar la asignatura <span className="text-danger">{datName}</span></strong> del archivo histórico del Estudiante?
            <div style={{fontSize:10}}>Esta opción no puede deshacerse y eliminará todas las calificaciones obtenidas en esta asignatura</div>
            </div>
        return (
            <CustomModal
                backgroundColor= {"#1f2f6e"}
                isopen =  {openDelMat}
                titulo = {<div style={{color:"#FFF"}}>Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {botonSi}
                boton2 = "No"
                funcion1 = { () => {
                        this.setState({
                            suiche: 1,
                            check: !this.state.check,
                            botonSi: <span><i className="fa fa-spinner fa-spin"></i> Espera</span>
                        }, () => {
                            let materia = datos.nombre;
                            let search = materia.indexOf(ELECTIVA);

                            let dataMat = "";
                            (search === 0) ? dataMat = valorElect.value : dataMat = datos.id;

                            /* notaResp = ""; */
                            EliminarDatHistorico(est.id, dataMat, (resp) => {
                                this.setState({
                                    botonSi: <span>Si</span>,
                                    openDelMat: false,
                                    suiche: 0,
                                    control: false,
                                    enLetras: "",
                                    te: this.props.datos.te,
                                    nota: "",
                                    valorTe: { value: '', label: '- Selecciona un Tipo de Evaluación -' },
                                    periodo: "",
                                }, () => {
                                    this.props.funcion()
                                    toast.info("Has eliminado correctamente el histórico de esta asignatura para el estudiante",{autoClose: 4000})
                                })
                            })
                        })
                    }
                }
            />
        );
    }

    cambiacheckElect = () => {
        let { valorElect } = this.state;
        let { datos, est } = this.props;
        if (valorElect.value === "") {
            toast.error("Debes seleccionar primero la materia Electiva",{autoClose: 4000})
        }else{
            if (this.state.check === false) {
                this.setState({
                    suiche: 1
                },() => {
                    AgregarDatHistoricoElect (est.id, valorElect, datos.id, (resp) => {
                        /* notaResp = resp; */
                        this.setState({
                            check: !this.state.check,
                            openDelMat: false,
                            suiche: 0,
                            control: true,
                            notaResp: resp[0],
                            valorElect: resp[1]
                        }, () => {
                            ConsultPeriodoHist (resp[0].IdReg, (resp) => {
                                this.setState({
                                    periodoSelect: resp[0],
                                    valorTe: resp[1]
                                })
                            })
                        })
                    })
                })
            }else{
                this.setState({
                    openDelMat: true,
                })
            }
        }
    }

    cambiacheck = () => {
        let { datos, est } = this.props;
        /* if (datos.Historico[0] === undefined) return null; */
        
        if (this.state.check === false) {
            this.setState({
                suiche: 1
            },() => {
                AgregarDatHistorico (est.id, datos.id, (resp) => {
                    /* notaResp = resp; */
                    this.setState({
                        check: !this.state.check,
                        openDelMat: false,
                        suiche: 0,
                        control: true,
                        notaResp: resp
                    }, () => {
                        ConsultPeriodoHist (resp.IdReg, (resp) => {
                            this.setState({
                                periodoSelect: resp[0],
                                valorTe: resp[1]
                            })
                        })
                    })
                })
            })
        }else{
            this.setState({
                openDelMat: true,
            })
        }
    }

    guardarPeriodoElect = () => {
        let { est } = this.props;
        let { periodoSelect, valorElect } = this.state;

        this.setState({
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A"
            },
            openDelMat: false
        }, () => {
            AddItem(periodoSelect.value, "periodo", est.id, valorElect.id,  (resp) => {
                if(resp.errores > 0) {
                    toast[resp.tipo](resp.mess,{autoClose: 4000});
                    this.setState({
                        preloader:{
                            icon: "fa fa-times",
                            color: "#A0555C"
                        }
                    })
                }else{
                    this.setState({
                        preloader:{
                            icon: "fa fa-check",
                            color: "#32704C"
                        }
                    })
                }
            })
        })
    }

    guardarPeriodo = () => {
        let { datos, est } = this.props;

        this.setState({
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A"
            },
            openDelMat: false
        }, () => {
            let datId = this.state.notaResp.IdReg;
            if (datos.Historico[0] !== undefined) datId = datos.Historico[0].hid
            AddItem(this.state.periodoSelect.value, "periodo", est.id, datId,  (resp) => {
                if(resp.errores > 0) {
                    toast[resp.tipo](resp.mess,{autoClose: 4000});
                    this.setState({
                        preloader:{
                            icon: "fa fa-times",
                            color: "#A0555C"
                        }
                    })
                }else{
                    this.setState({
                        preloader:{
                            icon: "fa fa-check",
                            color: "#32704C"
                        }
                    })
                }
            })
        })
    }

    tabEnter = (campo) => (e) => {
        let { num, cantidad } = this.props;
        if (e.which === 13){
            let next = num + 1;
            
            for (let i = 1; i < cantidad; i++){
                if (document.getElementById(`${campo}${next}`) === null) next ++;
            }

            if (document.getElementById(`${campo}${next}`) === null) return null;
            document.getElementById(`${campo}${next}`).focus();
        };
    }

    periodoElect = () => {
        if (this.state.check === true) {
            let { periodoSelect, periodos } = this.state;
            const customStyles = (base) => ({
                ...base,
                fontSize: 12,
            });
            return (
                <Select
                    styles={{menu: customStyles}}
                    isSearchable ={true}
                    value={periodoSelect}
                    onChange={this.valorPeriodoElect}
                    options={periodos}
                />
            )
        }
    }

    periodo = () => {
        let { datos, num } = this.props;
        let { periodoSelect, periodos } = this.state;
        let datPeriodo = "";
        const customStyles = (base) => ({
            ...base,
            fontSize: 12,
        });

        if (datos.Historico[0] !== undefined) datPeriodo = datos.Historico[0].periodo

        if (datos.Tipo === "CUALITATIVO"){
            if ( this.state.check === false ) return null;
            return (
                <Select
                    styles={{menu: customStyles}}
                    isSearchable ={true}
                    value={periodoSelect}
                    onChange={this.valorPeriodo}
                    options={periodos}
                />
            )
        }else{
            if ( this.state.sel === 1 || this.state.sel === 2 || this.state.control === false ) return null;
            if (datPeriodo !== "" || this.state.notaResp !== "")  return (
                <Select
                    styles={{menu: customStyles}}
                    isSearchable ={true}
                    value={periodoSelect}
                    onChange={this.valorPeriodo}
                    options={periodos}
                />
            )
        }
    }

    valorSelectTeElect = (valorTe) => {
        let { est } = this.props;
        let { valorElect } = this.state;

        this.setState({
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A"
            },
            valorTe,
            openDelMat: false,
        }, () => {
            GuardarTeHist (est.id, valorElect.id, valorTe.value, (resp) => {
                this.setState({
                    preloader: resp
                })
            })
        });
    }

    valorSelectTe = (valorTe) => {
        let { datos, est } = this.props;
        let datosId = this.state.notaResp.IdReg;
        if (datos.Historico[0] !== undefined) datosId = datos.Historico[0].hid;

        this.setState({
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A"
            },
            valorTe,
            openDelMat: false,
        }, () => {
            GuardarTeHist (est.id, datosId, valorTe.value, (resp) => {
                this.setState({
                    preloader: resp
                })
            })
        });
    }

    valorPeriodoElect = (periodoSelect) => {
        this.setState({
            periodoSelect
        }, () => {
            this.guardarPeriodoElect()
            this.props.funcRestPeriodo()
        })
    }

    valorPeriodo = (periodoSelect) => {
        this.setState({
            periodoSelect
        }, () => {
            this.guardarPeriodo()
            this.props.funcRestPeriodo()
        })
    }

    valorCualit = (CualitSelect) => {
        this.setState({
            CualitSelect
        }, () => {
            this.guardarNota("CUALITATIVO")
        })
    }

    valorCualitElect = (CualitSelect) => {
        this.setState({
            CualitSelect
        }, () => {

        })
    }

    teElect = () => {
        if (this.state.check === true) {
            let { valorTe, TeDisp } = this.state;

            return (
                <Select
                    title = "Selecciona un Tipo de Evaluación"
                    isSearchable ={true}
                    value={valorTe}
                    onChange={this.valorSelectTeElect}
                    options={ TeDisp }
                />
            )
        }
    }

    te = () => {
        let { datos } = this.props;
        let { valorTe, TeDisp } = this.state;

        let datPeriodo = "";
        if (datos.Historico[0] !== undefined) datPeriodo = datos.Historico[0].periodo

        if (datos.Tipo === "CUALITATIVO"){
            if ( this.state.check === false ) return null;

            return (
                <Select
                    title = "Selecciona un Tipo de Evaluación"
                    isSearchable ={true}
                    value={valorTe}
                    onChange={this.valorSelectTe}
                    options={ TeDisp }
                />
            )
        }

        if ( this.state.sel === 1 || this.state.sel === 2 || this.state.control === false) return null;

        if (datPeriodo !== "" || this.state.notaResp !== "") return (
            <Select
                title = "Selecciona un Tipo de Evaluación"
                isSearchable ={true}
                value={valorTe}
                onChange={this.valorSelectTe}
                options={ TeDisp }
            />
        )
    }

    guardarNotaElect  = () => {
        let { est } = this.props;
        let { nota, valorElect } = this.state;
        
        if (nota === "" || nota === "0") return null;
        
        this.setState({
            preloader:{
                icon: "fa fa-spinner fa-spin",
                color: "#9A9A9A"
            },
            openDelMat: false
        }, () => {

            let letras = [
                "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                "DIECINUEVE", "VEINTE"
            ];
    
            GuardarNotaHist (est.id, valorElect.id, nota, "", (resp) => {
                if (resp[1].status !== "") toast[resp[1].status](resp[1].mensaje,{autoClose: 4000});
                this.setState({
                    nota: resp[0],
                    preloader: resp[2],
                    enLetras: letras[resp[0] - 1]
                })
            })
        })
    }

    guardarNota = (tipo) => {
        let { datos, est } = this.props;
        let { nota, CualitSelect } = this.state;
        let datId = this.state.notaResp.IdReg;
        if (datos.Historico[0] !== undefined) datId = datos.Historico[0].hid
        
        if (tipo === "CUANTITATIVO"){
            if (nota === "" || nota === "0") return null;

            this.setState({
                preloader:{
                    icon: "fa fa-spinner fa-spin",
                    color: "#9A9A9A"
                },
                openDelMat: false
            }, () => {
    
                let letras = [
                    "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                    "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                    "DIECINUEVE", "VEINTE"
                ];
        
                GuardarNotaHist (est.id, datId, nota, CualitSelect, (resp) => {
                    if (resp[1].status !== "") toast[resp[1].status](resp[1].mensaje,{autoClose: 4000});
                    this.setState({
                        nota: resp[0],
                        preloader: resp[2],
                        enLetras: letras[resp[0] - 1]
                    })
                })
            })
        }else{
            if (CualitSelect.value === "") return null;
            this.setState({
                preloader:{
                    icon: "fa fa-spinner fa-spin",
                    color: "#9A9A9A"
                },
                openDelMat: false
            }, () => {
                GuardarNotaHist (est.id, datId, nota, CualitSelect, (resp) => {
                    if (resp[1].status !== "") toast[resp[1].status](resp[1].mensaje,{autoClose: 4000});
                    this.setState({
                        nota: resp[0],
                        preloader: resp[2],
                        enLetras: ""
                    })
                })
            })
        }
    }

    notaElect = (tipo) => {
        if (this.state.check === true) {
            let { num } = this.props;

            switch (tipo) {
                case "CUANTITATIVO":
                    return (
                        <input className="form-control" id = {`notaHist_${num}`} onKeyPress={this.tabEnter("notaHist_")} onBlur = {() => { this.guardarNotaElect()} } maxLength ={3} onChange={this.cambiaValor("nota")} type= "text" value={this.state.nota} title="Agregar una calificacion al estudiante"/>
                    )
                case "CUALITATIVO":
                    let { CualitSelect, Cualit } = this.state;
                    return(
                        <div title = "Selecciona una Calificación">
                            <Select
                                isSearchable ={true}
                                value={CualitSelect}
                                onChange={this.valorCualitElect}
                                options={ Cualit }
                            />
                        </div>
                    )
                default:
                    return (<i className="fa fa-spinner fa-spin"></i>)
            }
            
        }
    }

    nota = (tipo) => {
        let { datos, num } = this.props;

        let datPeriodo = "";
        if (datos.Historico[0] !== undefined) datPeriodo = datos.Historico[0].periodo

        if (datPeriodo !== "" || this.state.notaResp !== ""){
            switch (tipo) {
                case "CUANTITATIVO":
                    if ( this.state.sel === 1 || this.state.sel === 2 || this.state.control === false) return null;
                    return (
                        <input className="form-control" id = {`notaHist_${num}`} onKeyPress={this.tabEnter("notaHist_")} onBlur = {() => { this.guardarNota("CUANTITATIVO") } } maxLength ={3} onChange={this.cambiaValor("nota")} type= "text" value={this.state.nota} title="Agregar una calificacion al estudiante"/>
                    )
                case "CUALITATIVO":
                    let { CualitSelect, Cualit } = this.state;
                    if ( this.state.check === false ) return null;

                    return(
                        <div title = "Selecciona una Calificación">
                            <Select
                                isSearchable ={true}
                                value={CualitSelect}
                                onChange={this.valorCualit}
                                options={ Cualit }
                            />
                        </div>
                    )
                default:
                    return (<i className="fa fa-spinner fa-spin"></i>)
            }
        }
    }

    enLetras = () => {
        /* let { datos } = this.props;
        
        let datLetras = 0;
        if (datos.Historico[0] !== undefined) datLetras = datos.Historico[0].nota */

        let letras = [
            "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
            "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
            "DIECINUEVE", "VEINTE"
        ];

       this.setState({
            enLetras: letras[this.state.nota - 1]
       })
    }

    switch = (materia) => {
        let { check, sel, selElec, suiche } = this.state;
        
        switch (sel) {
            case 0:
                if (suiche === 1){
                    return (<i className="fa fa-spinner fa-spin"></i>)
                }else{
                    let search = materia.indexOf(ELECTIVA);
                    if (search === 0) {
                        if (selElec === 2) {
                            return (<i className="fa fa-spinner fa-spin"></i>)
                        }else{
                            return (<Switch height={12} width={24} onChange={this.cambiacheckElect} checked={check} />)
                        }
                    }else{
                        return (<Switch height={12} width={24} onChange={this.cambiacheck} checked={check} />)
                    }
                }
            case 1:
                return null;
            case 2:
                return (<i className="fa fa-spinner fa-spin"></i>)
            default:
                return (<i className="fa fa-spinner fa-spin"></i>)
        }
    }

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    materiasHistApl = (materias) => {
        let num = 1
        let numero = () => { return num ++; }

        const styles = {
            minHeight: 40,
            fontSize: 10,
            padding: 5
        }
        return (
            <div className="table-responsive">
                <Table bordered hover striped>
                    <tbody>
                        <tr className="custon-back-color">
                            <td width="20%" style={styles} align="center"><strong>PERIODO</strong></td>
                            <td width="35%" style={styles} align="center"><strong>T-E</strong></td>
                            <td width="20%" style={styles} align="center"><strong>NOTA</strong></td>
                            <td width="25%" style={styles} align="center"><strong>LETRAS</strong></td>
                        </tr>
                        {materias.map(option => (
                            <MateriaHistApl
                            periodos = {this.props.allperiodos}
                            est = {this.props.est.id}
                            preloader = {() => {this.setState({
                                preloader:{ icon: "fa fa-spinner fa-spin", color: "#9A9A9A" },
                                openDelMat: false
                            })}}
                            preloaderOk = {() => {
                                this.setState({ preloader:{ icon: "fa fa-check", color: "#32704C" },
                                openDelMat: false
                            })}}
                            preloaderNok = {() => {
                                this.setState({ preloader:{ icon: "fa fa-times", color: "#A0555C" },
                                openDelMat: false
                            })}}
                            num = { numero() } key={option.hid} datos={option}/>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }

    historico = (materia, tipo) => {
        let { iconChevron } = this.state;
        let { datos } = this.props;

        const styles = {
            minHeight: 40,
            fontSize: 10,
            padding: 3
        }

        if (datos.Historico.length > 1){
            return (
                <td colSpan={4} align="left" style={styles}>
                    <PanelGroup
                        accordion
                        activeKey={this.state.activeKey}
                        /* className="custom-alert-info" */
                        id={`materia_${datos.codigo}`}
                        style={{marginTop: 3}}
                    >
                        <Panel eventKey={1}>
                            <Panel.Heading >
                                <Panel.Title toggle style={{color:"#1f2f6e"}} onClick={this.cambiaIcon}>
                                    <Row>
                                        <Col md={10} style={{fontSize:10}}>
                                            VER EL HISTÓRICO DE ESTA MATERIA
                                        </Col>
                                        <Col md={2} align="right">
                                            <i className={iconChevron} style={{fontSize:10}}></i>
                                        </Col>
                                    </Row>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible style={{padding:0}}>
                                {this.materiasHistApl(datos.Historico)}
                            </Panel.Body>
                        </Panel>
                    </PanelGroup>
                </td>
            )
        }else{
            let search = materia.indexOf(ELECTIVA);

            let tipoElect = () => {
                if (tipo === "CUANTITATIVO") return (
                    <React.Fragment>
                        <td align="center" style={styles}><span className="text-muted">...</span>{this.notaElect(tipo)}</td>
                        <td align="center" style={styles}>{this.state.enLetras}</td>
                    </React.Fragment>
                )
                return (
                    <td align="center" colSpan= {2} style={styles}><span className="text-muted">...</span>{this.notaElect(tipo)}</td>
                )
            }

            let tipoR = () => {
                if (tipo === "CUANTITATIVO") return (
                    <React.Fragment>
                        <td align="center" style={styles}>{this.nota(tipo)}</td>
                        <td align="center" style={styles}>{this.state.enLetras}</td>
                    </React.Fragment>
                )
                return (
                    <td align="center" colSpan= {2} style={styles}>{this.nota(tipo)}</td>
                )
            }

            if (search === 0) return (
                <React.Fragment>
                    <td align="center" style={styles}><span className="text-muted">...</span>{this.periodoElect()}</td>
                    <td align="center" style={styles}><span className="text-muted">...</span>{this.teElect()}</td>
                    {tipoElect()}
                </React.Fragment>
            )

            return (
                <React.Fragment>
                    <td align="center" style={styles}>{this.periodo()}</td>
                    <td align="center" style={styles}>{this.te()}</td>
                    {tipoR()}
                </React.Fragment>
            )
        }
    }

    nombreMat = (materia) => {
        let { Electivas, valorElect } = this.state;
        let search = materia.indexOf(ELECTIVA);

        if (search === 0) return (
            <div>
                <span className="text-muted">{materia}</span>
                <Select
                    title = "Selecciona una Electiva"
                    isSearchable ={true}
                    value={valorElect}
                    onChange={this.valorElectiva}
                    options={ Electivas }
                />
            </div>
        )

        return materia
    }

    render() {
        let { datos } = this.props;
        let { preloader, codigoMat } = this.state;

        const styles = {
            minHeight: 40,
            fontSize: 10,
        }

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>
                        {this.switch(datos.nombre)}
                    </td>
                    <td align="center" style={styles}>{codigoMat}</td>
                    <td style={styles}>{this.nombreMat(datos.nombre)}</td>
                    {this.historico(datos.nombre, datos.Tipo)}
                    <td align="center" style={styles}><i className={preloader.icon} style={{color: preloader.color}}></i></td>
                </tr>
                {this.modalDelMat()}
            </React.Fragment>
        );
    }
}
 
export default MateriaHist;


// WEBPACK FOOTER //
// ./src/views/Registros/HistoricoContent/MateriaHist.jsx